import { Component, OnInit } from '@angular/core';
import * as firebase from 'firebase';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AmbitService } from '../ambit.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {

  public sendCount:number = 0;
  public rejectCount:number = 0;
  public loading:boolean = false;
  public successMsg:boolean = false;
  public searchList: any = ['title'];
  public notificationData:any = {
    userType: 'All Users',
    title:'',
    message:'',
  }
  public recieversList:any = [];
  public notificationsList:any = [];
  
  constructor(public route: ActivatedRoute,
    public router: Router,
    public service: AmbitService,
    public http: HttpClient) {
      if(this.service.adminUser.userAccess.notifications =='None') {
        this.router.navigate(['/home']);
      }
      this.getNotificationsList();
  }

  ngOnInit() {
  }

  getNotificationsList() {
    var self = this;
    self.loading = true;
    firebase.database().ref().child('Notifications')
      .once('value', function (snapshot) {
        self.notificationsList = [];
        var data = snapshot.val();
        if (data) {
          for (var key in data) {
            
            if(data[key].senderId && data[key].senderId=='superAdmin') {
              data[key].notificationID = key;
              self.notificationsList.push(data[key]);
            }
          
          }
        }
        self.loading = false;
      }).catch((error)=>{
        console.log(error);
        self.loading = false;
      })
  }

  sendNotification() {
    var self=this;

    if(self.notificationData.userType=='All Users') {
      self.recieversList = self.service.allUsersList ;
    } else if(self.notificationData.userType=='Drivers') {
      self.recieversList = self.service.driversList ;
    } else if(self.notificationData.userType=='Passengers') {
      self.recieversList = self.service.passengersList ;
    } 

    
    if(self.recieversList.length) {
      self.loading = true;
      for(var i=0; i<self.recieversList.length; i++) { 
        var  formData = {
          title: self.notificationData.title,
          message: self.notificationData.message,
          timeStamp: Number(new Date())
        };
        self.sendUserNotification( self.recieversList[i])
      }

      //self.saveNotificationFirebase()
    }
  }


  sendUserNotification(user) {
    var self = this;
    if (!user.deviceToken) {
      self.rejectCount++;
      if(self.rejectCount + self.sendCount ==self.recieversList.length) {
        self.saveNotificationFirebase();
       }
      return;
    }

    var addMessage = firebase.functions().httpsCallable('sendNotification');
    addMessage({
      title: self.notificationData.title,
      message: self.notificationData.message,
      deviceToken: user.deviceToken,
    }).then((result) => {
      self.sendCount++;
      if(self.rejectCount + self.sendCount ==self.recieversList.length) {
        self.saveNotificationFirebase();
       }
      console.log(result);
    }, (error) => {
      self.rejectCount++;
      if(self.rejectCount + self.sendCount ==self.recieversList.length) {
       self.saveNotificationFirebase();
      }
      console.log(error);
    });
  }


  saveNotificationFirebase() {
    var self = this;
    var updates = {};
    var newPostKey = firebase.database().ref().child('Notifications/').push().key;
    var postData = {
      title: self.notificationData.title,
      message: self.notificationData.message,
      receiver: self.notificationData.userType,
      senderId: 'superAdmin',
      timeStamp: Number(new Date()),
    };
    updates['/Notifications/' + "/" + newPostKey] = postData;
    firebase.database().ref().update(updates).then(() => {
      self.successMsg = true;
      self.loading = false;
      postData['notificationId'] = newPostKey ;
      self.notificationsList.push(postData);
      self.notificationData = {
        userType: 'All Users',
        title:'',
        message:'',
      }
      self.sendCount = 0;
      self.rejectCount = 0;
      /* self.createToast(" Reviewed!!"); */
    }).catch( (error)=> {
      self.loading = false;
      alert(error.message);
    });
  }

}
